import React, { useEffect, useState } from "react";
import "./Login.css";
import {
  // useDispatch,
  useSelector,
} from "react-redux";
import { fetchLoggedInDetails } from "../../store/apiActions";
import loginImage from "../../assets/images/back1234.png";
import vectorImage from "../../assets/images/Vector.png";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
// import { env } from "../../environment";
import { encrypted } from "../../utils/Utility";
import { env } from "../../environment.template";
function Login() {
  // const dispatch = useDispatch();
  const loggedInDetails = useSelector((state) => state.api.loggedInDetails);
  const [loginState, setLoginState] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    checkAndLoginUser();
  }, [location.search]);

  useEffect(() => {
    // localStorage.clear();
    userDetails();
  }, []);

  const checkAndLoginUser = () => {
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get("code");
    const error = queryParams.get("error");
    if (code) {
      setLoginState(true);
      fetchUserTokenAndAuthenticate(code);
    } else if (error) {
      // Handle the error, e.g., show an error message
    }
  };

  const fetchUserTokenAndAuthenticate = async (code) => {
    setLoginState(true); // Set loading state before making the request
    try {
      const response = await axios.post(`${env.baseURL}/auth/azure/authenticate`, {
        encryptedBody: encrypted.encrypt(JSON.stringify({ code: code })),
      });
      let item = JSON.parse(encrypted.decrypt(response.data.encryptedBody));
      localStorage.setItem("token", item.token);
      localStorage.setItem("LoggedInDetails", JSON.stringify(item.app_user));
      localStorage.setItem("isLogin", true);
      setLoginState(false);
      navigate("/dashboard");
      toast.success("You are successfully logged in");
    } catch (error) {
      setLoginState(false); // Reset login state on error
      toast.error(error.message);
    } finally {
      setLoginState(false); // Ensure the loading state is reset
    }
  };

  // const fetchUserTokenSuccess = async (successResponse) => {
  //   if (successResponse) {
  //     localStorage.setItem("token", successResponse);
  //     toast.success("You are successfully logged in");
  //     setLoginState(false);
  //     navigate("/dashboard");
  //   }
  // };

  const userDetails = () => {
    fetchLoggedInDetails(`${env.baseURL}/app-user-profile`);
  };

  useEffect(() => { 
    if (loggedInDetails) {
      //  const userDetails = {dropdown:loggedInDetails?.data?.appUserRoleMappings[0],role:loggedInDetails?.data?.role};
      //  localStorage.setItem("loggedInDetails", JSON.stringify(userDetails));
    }
  }, [loggedInDetails]);

  const fetchAuthenticatedAPI = () => {
    axios
      .get(`${env.baseURL}/auth/azure/auth-info`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        let data = JSON.parse(encrypted.decrypt(response.data.encryptedBody));
        ssoSignIn(data);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  const ssoSignIn = (props) => {
    const item = props;
    const loginUrl = item.login_url;
    const logOutUrl = item.logout_url;
    if (loginUrl) {
      localStorage.setItem("loginUrl", loginUrl);
      window.location.href = loginUrl;
    }
    if (logOutUrl) {
      localStorage.setItem("logOutUrl", logOutUrl);
    }
  };

  return (
    <>
      <ToastContainer closeButton={true} position="top-right" />
      {!loginState ? (
        <div
          style={{
            backgroundImage: `url(${loginImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "100%",
            overflow: "hidden",
          }}
        >
          <div className="parentLoginContainer">
            <div className="parentTextContainer">
              <div className="textContainer">
                <div>
                  <img src={vectorImage} alt="vector" />
                </div>
                <div className="distributor360Container">
                  <span>DOSSIER</span>
                  <span className="welcomContainer">GenAI</span>
                </div>
                <div className="loginTo">
                  <span>Log in to continue</span>
                </div>
                <div className="loginButtonContainer">
                  <button
                    className="buttonAlignment"
                    onClick={fetchAuthenticatedAPI}
                    // onClick={pendingFeature}
                  >
                    Log In
                  </button>
                </div>
              </div>
              {/* <Footer /> */}
          <div className="copyright-label-login">
            © 2025DossierGenAI. All Rights Reserved.
          </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="loginWaitContainer">Please wait for a while...</div>
      )}
    </>
  );
}

export default Login;
